var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconEyeOn = function SvgIconEyeOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.234 10a2.187 2.187 0 1 0 4.375 0 2.187 2.187 0 0 0-4.375 0m10.668-.504c-1.851-3.9-4.65-5.863-8.402-5.863-3.754 0-6.55 1.963-8.402 5.865a1.178 1.178 0 0 0 0 1.006c1.851 3.9 4.65 5.863 8.402 5.863 3.754 0 6.55-1.963 8.402-5.865.15-.317.15-.684 0-1.006m-8.48 3.941a3.438 3.438 0 1 1 0-6.875 3.438 3.438 0 0 1 0 6.876"
  })));
};
export default SvgIconEyeOn;